// src/shared/utils/storage.js

export const safeJSONParse = (value) => {
  try {
    return value && value !== "undefined" ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export const getUserFromStorage = () =>
  safeJSONParse(localStorage.getItem("user"));

export const getTokenFromStorage = () =>
  localStorage.getItem("access_token");

export const setAuthStorage = (user, token) => {
  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
  if (token) {
    localStorage.setItem("access_token", token);
  }
};

export const clearAuthStorage = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("access_token");
};